import { BankAccount as BaseBankAccount } from '@models/common/bank-account.model';

import { SimpleEntityActions } from '@app/classes';

export class BankAccount extends BaseBankAccount {
    protected static _resource = 'companyManagement/companies/:company/employees/:employee/bankAccounts';

    static permission = new SimpleEntityActions('bankAccount');
}
